import { render, staticRenderFns } from "./Esg.vue?vue&type=template&id=1bf0beb8&"
import script from "./Esg.vue?vue&type=script&lang=js&"
export * from "./Esg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports